import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Icon } from "../../components/Icon";
import { api } from "../../data";
import { creatorBereichsWechsel, creatorNav } from "../../app/nav";
import { useCreatorContext } from "./ui";
import { SignOutButton } from "./Konto";
import { useT } from "./sprache";

/**
 * „Mehr“ auf dem Handy (Befund 5): alle Ziele des Creator-Portals, die unten keinen Platz haben (Kalender, Verträge,
 * Profil, Benachrichtigungen, Instagram, Konto), dazu der Bereichswechsel bei Doppelrolle und Abmelden.
 */
export function Mehr() {
  const { ws, account, lang, scope } = useCreatorContext();
  const t = useT();
  const ig = useQuery({
    queryKey: ["creator", scope.talentId, "ig-enabled"],
    queryFn: async () => (await api.select<{ ig_enabled: boolean }>("talents", { columns: "ig_enabled", filters: [["id", "eq", scope.talentId]] }))[0]?.ig_enabled ?? false,
    staleTime: 5 * 60_000,
  });
  const items = [
    ...creatorNav(lang),
    { label: t("Benachrichtigungen", "Notifications"), to: "/creator/benachrichtigungen", icon: "bell" as const },
    ...(ig.data ? [{ label: "Instagram", to: "/creator/instagram", icon: "chart" as const }] : []),
    // „Mein Konto“ (eigenes Creator-Konto, S2/0540) bzw. „Zur Agentur“ für Teammitglieder
    ...(account ? creatorBereichsWechsel(account, lang) : []),
  ];
  return (
    <main id="main" className="content tk-cr tk-cr-mehr">
      <div className="pagehead">
        <div>
          <div className="eyebrow">{ws.org.name}</div>
          <h1>{t("Mehr", "More")}</h1>
        </div>
      </div>
      <nav className="panel stack tk-menu" aria-label={t("Alle Bereiche", "All sections")}>
        {items.map((i) => (
          <Link key={i.to} to={i.to} className="task">
            <span className="row"><Icon name={i.icon} />{i.label}</span>
            <span aria-hidden="true">›</span>
          </Link>
        ))}
      </nav>
      <div className="row">
        <SignOutButton />
      </div>
    </main>
  );
}
